import $ from 'jquery'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'

import { SfTime } from '@app/adapters/time'
import {
  isElementAnchorInView,
  scrollableContentSelector,
} from '@app/utils/domHelpers'

const targetFormat = (target) => {
  return (
    target.dataset.momentJsFormat || target.dataset.dateFormat.toUpperCase()
  )
}

const parseDate = (target, date) => {
  if (!date || !date.trim()) return

  const momentDate = SfTime(date, targetFormat(target))
  if (!momentDate.isValid()) return

  return momentDate.toDate()
}

const formatDate = (target, date) => SfTime(date).format(targetFormat(target))

// Delegated on the persistent document and bound once at module scope, so it
// also covers inputs added later (including inside lazy turbo frames).
$(document).on(
  'click focus',
  '[data-behaviour~="markdown-datepicker"]',
  (event) => {
    const target = event.target

    if (!target._flatpickr) {
      let scrollParent

      const followScroll = () => {
        if (
          scrollParent instanceof HTMLElement &&
          !isElementAnchorInView(target, scrollParent)
        ) {
          target._flatpickr?.close()
          return
        }

        target._flatpickr?._positionCalendar()
      }

      flatpickr(target, {
        position: 'below left',
        allowInput: true,
        formatDate: (date) => formatDate(target, date),
        parseDate: (date) => parseDate(target, date),
        onOpen: () => {
          scrollParent = target.closest(scrollableContentSelector) || window
          scrollParent.addEventListener('scroll', followScroll, {
            passive: true,
          })
        },
        onClose: () => {
          scrollParent?.removeEventListener('scroll', followScroll)
        },
      })
    }
  }
)
